// removed by extract-text-webpack-plugin
module.exports = {"label":"src-scripts-components-MonitorCard-__monitorCard___label","data":"src-scripts-components-MonitorCard-__monitorCard___data","routeType":"src-scripts-components-MonitorCard-__monitorCard___routeType","routeTitle":"src-scripts-components-MonitorCard-__monitorCard___routeTitle","monitorCard":"src-scripts-components-MonitorCard-__monitorCard___monitorCard","entrance":"src-scripts-components-MonitorCard-__monitorCard___entrance","routeContainer":"src-scripts-components-MonitorCard-__monitorCard___routeContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/MonitorCard/monitorCard.css
// module id = 633
// module chunks = 0